import cx from 'classnames'
import { forwardRef, useRef, useState } from 'react'
import { MdSearch } from 'react-icons/md'
import { animated, useSpring } from 'react-spring'

let AnimatedMdSearch = animated(MdSearch)

interface SearchInputProps {
  value: string
  onChange: (value: string) => void
}

export let SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(({ value, onChange }, ref) => {
  let [ isFocused, setIsFocused ] = useState(false)
  let hasValue = value.length > 0
  let isActive = isFocused || hasValue

  let wrapperRef = useRef<HTMLDivElement>(null)

  let iconStyle = useSpring({
    opacity: isActive ? 0.25 : 1,
    transform: `translateX(${isActive ? -28 : 0}px)`
  })

  let inputStyle = useSpring({
    transform: `translateX(${isActive ? 8 : 28}px)`
  })

  return (
    <div
      ref={wrapperRef}
      className='relative flex-grow w-full rounded overflow-hidden focus-within:border-purple-400'
    >
      <AnimatedMdSearch
        size={18}
        className={cx('absolute left-[12px] top-[12px] text-gray-400 border-pink-400')}
        style={iconStyle}
      />

      <animated.input
        ref={ref}
        type='search'
        placeholder='Search chats'
        className='form-input w-full py-[12px] pb-[12.5px] px-2 font-inter outline-none border-none bg-gray-100 rounded-xl border border-green-400 focus:border-none focus:ring-0 bg-transparent appearance-none'
        value={value}
        onChange={event => {
          onChange(event.target.value)
        }}
        onFocus={() => {
          setIsFocused(true)
        }}
        onBlur={() => {
          setIsFocused(false)
        }}
        style={inputStyle}
      />
    </div>
  )
})

SearchInput.displayName = 'SearchInput'
